var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.526 5.116 13.347.66 1.658 9.997 1.01 9.99V10H.5v12h21V10h-.962l-1.914-5.599-2.098.715ZM18.425 10H8.397l7.469-2.546 1.522-.487L18.425 10ZM14.55 5.79 6.84 8.418l6.106-4.878 1.604 2.25ZM2.5 18.17v-4.34A3.008 3.008 0 0 0 4.33 12h13.34a3.01 3.01 0 0 0 1.83 1.83v4.34A3.008 3.008 0 0 0 17.67 20H4.332A3.01 3.01 0 0 0 2.5 18.17Z",
    fill: "#647F29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.451cd410411dedee71cce582120b2490.svg";
export { ForwardRef as ReactComponent };